<markant-platform-guided-tour-wrapper
  [guidedTourSteps]="myOrganizationSteps"
  [onNext]="nextButtonCallback"
  [onBack]="backButtonCallback"
  [currentStep]="currentStep"
  [enableClickThrough]="enableClickThrough"
></markant-platform-guided-tour-wrapper>
